module.exports = __webpack_public_path__ + "img/1389.e4dd4471.gif";